const getIterableBackendBaseApiUrl = require("./getIterableBackendBaseApiUrl");

/**
 * @param preferenceCenterFormData {{[p: string]: string} | PreferenceCenterFormData}
 * @return {Promise<void>}
 */
module.exports = async function submitPreferenceCenterUpdateUser(preferenceCenterFormData) {
    const baseUrl = getIterableBackendBaseApiUrl();

    await fetch(`${baseUrl}/updateUser`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(preferenceCenterFormData),
    });
}